import { Component, OnInit, Output, EventEmitter, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "../../core/services/auth.service";
import { CookieService } from "ngx-cookie-service";
import { LanguageService } from "../../core/services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { UtilsService } from "src/app/core/services/utils.service";
import { EmployeeStore } from "src/app/core/services/Stores/employee.store";
import { Observable, map, of, finalize } from "rxjs";
import { TenantStore } from "src/app/core/services/Stores/tenant.store";
import { InactivityService } from "src/app/core/services/inactivity.service";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  username: string;
  nickname;
  waitingHRApproval$: Observable<any>;
  canManageEmployeeProfile: boolean;
  totalNotifications: Observable<any>;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService,
    private utilsService: UtilsService,
    private employeeStore: EmployeeStore,
    public tenantStore: TenantStore,
    private inactivityService: InactivityService
  ) { }

  listLang = [
    { text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
    { text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
    { text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
    { text: "Italian", flag: "assets/images/flags/italy.jpg", lang: "it" },
    { text: "Russian", flag: "assets/images/flags/russia.jpg", lang: "ru" },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;

    const user = this.authService.currentUser();
    this.username = user.payload.name;
    this.nickname = this.utilsService.getUserNickname(this.username);

    if (this.authService.canManageEmployeeProfile)
      this.employeeStore.getEmployeesWaitingHRApproval();

    this.canManageEmployeeProfile = this.authService.canManageEmployeeProfile;
    this.waitingHRApproval$ = this.employeeStore.waitingHRApproval.pipe(
      map((items) =>
        items.map((item) => ({
          ...item,
          nickname: this.utilsService.getUserNickname(item.name),
        }))
      )
    );

    this.totalNotifications = this.canManageEmployeeProfile
      ? this.waitingHRApproval$.pipe(map((items) => items.length))
      : of(null);
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    // Para o monitoramento de inatividade antes do logout
    this.inactivityService.stopMonitoring();

    this.authService
      .logout()
      .pipe(finalize(() => this.router.navigate(["account/login"])))
      .subscribe();
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
